var NumbersEditor = angular.module("NumbersEditor", ['common', 'ngRoute', 'ngAnimate', 'ngLocale', 'ngResource', 'ngAnimate', 'ui.bootstrap', 'dialogs', 'angular-loading-bar', 'angularMoment']);

NumbersEditor.config(['$routeProvider', function ($routeProvider) {
    $routeProvider
        .when("/",
        {
            controller: "HomeController",
            templateUrl: "/Partials/home.html?v=20200826"
        })
        .when("/game/:gameId",
        {
            controller: "GameController",
            templateUrl: "/Partials/game.html?v=20200804"
        })
        .when("/event/:eventId",
        {
            controller: "EventController",
            templateUrl: "/Partials/event.html?v=20200916"
        })
        .when("/add",
        {
            controller: "NewGameController",
            templateUrl: "/Partials/add.html?v=20200722"
        })
        .when("/add/:date",
        {
            controller: "NewGameController",
            templateUrl: "/Partials/add.html"
        })
        .when("/search",
        {
            controller: "SearchController",
            templateUrl: "/Partials/search.html?v=20200722"
        })
        .when("/settings",
        {
            controller: "SettingsController",
            templateUrl: "/Partials/settings.html"
        })
        .when("/certificate/:eventId",
        {
            controller: "preDrawCertificateController",
            templateUrl: "/Partials/preDrawCertificate.html"
        })
        .when("/postdrawcertificate/:eventId",
        {
            controller: "postDrawCertificateController",
            templateUrl: "/Partials/postDrawCertificate.html"
        })
        .when("/predrawweight/:eventId",
        {
            controller: "PreDrawWeightController",
            templateUrl: "/Partials/preDrawWeight.html"
        })
        .when("/postdrawweight/:eventId",
        {
            controller: "PostDrawWeightController",
            templateUrl: "/Partials/postDrawWeight.html"
        })
        .when("/publishresults/:eventId",
        {
            controller: "PublishResultsController",
            templateUrl: "/Partials/publishresults.html"
            })
        .when("/newadhoc",
            {
                controller: "NewAdhocController",
                templateUrl: "/Partials/newAdhoc.html?v=20200812"
            })
        .when("/gameedit/:gameId",
            {
                controller: "GameEditController",
                templateUrl: "/Partials/gameEdit.html?v=20200804"
            })
        .when("/setupsportcodes",
            {
                controller: "SetupSportCodeController",
                templateUrl: "/Partials/setupSportCode.html"
            })
        .when("/sportcodeedit/:sportCode",
            {
                controller: "SportCodeEditController",
                templateUrl: "/Partials/sportCodeEdit.html?v=20201008"
            })
        .when("/sportcodeadd",
            {
                controller: "SportCodeEditController",
                templateUrl: "/Partials/sportCodeEdit.html?v=20201008"
            })
        .otherwise({ redirectTo: "/" });
}]);

NumbersEditor.config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptorFactory');
}]);

NumbersEditor.run(['$rootScope', function ($rootScope) {
    $rootScope.SetAppTitle = function (mainTitle, subtitle) {
        $rootScope.title = "Numbers Editor - " + mainTitle;
        $rootScope.subtitle = subtitle;
    };
}]);
